/* eslint no-script-url: 0 */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'

import { withStyles } from '@material-ui/core/styles'

import {
  Drawer,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Hidden,
  Divider,
  Paper,
} from '@material-ui/core'

import {
  Menu as MenuIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  ArrowBack as ArrowBackIcon,
} from '@material-ui/icons'

import { settingsTabs, appTargets } from '../../utils/constants'
import { checkIsAppTargetRoute, getApiUrl } from '../../utils/common'

// local components

import ExpandableList from '../../components/common/ExpandableList/ExpandableList'
import MasterCatalogPage from './MasterCatalog/MasterCatalogPage'
import InsightsPage from './Insights/InsightsPage'
import CompanyPage from './Company/CompanyPage'
import IntegrationPage from './Integration/IntegrationPage'
import PluginsPage from './Plugins/PluginsPage'
import ShopPage from './Shop/ShopPage'
import BillingPage from './Billing/BillingPage'
import DevelopmentPage from './Development/DevelopmentPage'
import ManageEmployees from './Employees/ManageEmployees'
import { logOut } from '../../utils/api'
import {
  changeShop,
  switchApp,
  getCurrentSession,
  getCurrentSessionNoStore,
} from '../../actions/auth'
import _ from 'lodash'
import { distributionLogo, retailLogo, growLogo } from '../../assets'
import classNames from 'classnames'
import Footer from '../Footer'
import { getCompanyFeatures, setCompanyFeatures } from '../../actions/company'
import { isLabelMakerEnabled } from '../../actions/shop'
import ManageManufacturing from './Manufacturing'
import ApolloRoute from '../../graphql/ApolloRoute'
import { ProtectedRoute } from '../../components/Auth/ProtectedRoute'
import { checkIfNalTaxesOnlyFlagIsEnabled } from '../../actions/compliance'
import { initHubSpot } from '../../utils/crm'
import config from '../../config/config'
import { LocalStorage } from '../../utils/localStorage'
import { isFeatureFlagEnable } from '../../api/unleash'
import { UnleashToggles } from '../../types/unleashToggles'
import { getUnleashFlag } from '../../actions/flag'

const apiUrl = getApiUrl()
const drawerWidth = '290'
const isDevEnvironment = config.apiFB

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    position: 'absolute',
    marginLeft: `${drawerWidth}`,
    color: 'white',
    [theme.breakpoints.up('md')]: {
      width: `calc(${drawerWidth}-20%)`,
    },
  },
  appBarShift: {
    marginLeft: `${drawerWidth}px`,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  navIconHide: {
    marginRight: 5,
  },
  toolbar: {
    ...theme.mixins.toolbar,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 30,
  },
  stripedLink: {
    textDecoration: 'none',
    color: 'black',
  },
  shopToolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',
  },
  drawerPaper: {
    width: `${drawerWidth}px`,
    height: '100%',
    border: 'none',
    [theme.breakpoints.up('md')]: {
      position: 'relative',
    },
  },
  docked: {
    height: '100%',
  },
  content: {
    width: `calc(100% - ${drawerWidth}px - ${theme.spacing.unit * 3 * 2}px)`,
    overflowY: 'auto',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
})

class ResponsiveDrawer extends React.Component {
  _isMounted = false
  state = {
    mobileOpen: true,
    dropdown: false,
    companyFeatures: {},
    filteredList: [],
    enableMfg: false,
    allowDelivery: true,
    deliveryTaxTab: {},
  }

  getSession() {
    if (window && window.localStorage) {
      return window.localStorage.getObject('session')
    }

    return null
  }

  componentWillReceiveProps(nextProps) {
    const session = this.getSession()
    const { assignedShop } = session || {}
    const { allowDelivery } = assignedShop || {}
    //if update to a state that has different access to delivery, change tab in order to avoid to do a refresh
    if (typeof allowDelivery !== 'undefined' && allowDelivery != this.state.allowDelivery) {
      let { filteredList, deliveryTaxTab } = this.state
      filteredList &&
        filteredList.forEach((tab, index) => {
          if (tab.url == 'shop') {
            if (allowDelivery) {
              if (deliveryTaxTab) {
                //adding delivery tax tab
                tab.childrenList.splice(1, 0, deliveryTaxTab)
              }
            } else {
              //removing delivery tax tab
              tab.childrenList = tab.childrenList.filter((child) => child.url != 'deliverytax')
            }
            filteredList[index] = tab
          }
        })
      this.setState({ allowDelivery, filteredList })
    }
  }

  getUnleashFlag = async (flag, saveInLocalStorage) => {
    const isMFEPageEnabled = await isFeatureFlagEnable(flag).catch((_) => false)
    if (!!saveInLocalStorage) {
      localStorage.setItem(saveInLocalStorage, isMFEPageEnabled)
    }
    return isMFEPageEnabled
  }

  setFeatureFlags = async () => {
    const taxesPageFlag = await this.props.dispatch(
      getUnleashFlag(UnleashToggles.CAN_USE_TAXES_MFE),
    )
    const systemActivityLogPageFlag = await this.props.dispatch(
      getUnleashFlag(UnleashToggles.CAN_USE_SYSTEM_ACTIVITY_LOG_MFE),
    )
    const feesPageFlag = await this.getUnleashFlag(
      UnleashToggles.CAN_USE_FEES_MFE,
      'isMFEFeesPageEnabled',
    )
    const paymentPageFlag = await this.getUnleashFlag(
      UnleashToggles.MFE_PAYMENT_PAGE,
      'isMFEPaymentPageEnabled',
    )

    this.setState(({ filteredList, ...otherState }) => ({
      ...otherState,
      filteredList: (filteredList || []).map((tab) => ({
        ...tab,
        childrenList: tab.childrenList.map((subItem) => {
          switch (subItem.url) {
            case 'taxes':
              return { ...subItem, featureFlagEnabled: taxesPageFlag }
            case 'system-activity-log':
              return { ...subItem, featureFlagEnabled: systemActivityLogPageFlag }
            case 'fees':
              return { ...subItem, featureFlagEnabled: feesPageFlag }
            case 'newPaymentOptions':
              return { ...subItem, featureFlagEnabled: paymentPageFlag }
            default:
              return subItem
          }
        }),
      })),
    }))
  }

  async componentDidMount() {
    const { dispatch } = this.props
    this._isMounted = true
    window.addEventListener('click', () => {
      if (this.state.dropdown) {
        this.setState({ dropdown: false })
      }
    })
    if (window.innerWidth < 989) {
      this.setState({
        mobileOpen: false,
      })
    }
    window.addEventListener('resize', () =>
      this.setState((prevState) => {
        if (prevState.mobileOpen && window.innerWidth < 989) {
          this.handleDrawerToggle()
        }
        if (!prevState.mobileOpen && window.innerWidth > 989) {
          this.handleDrawerToggle()
        }
      }),
    )
    this.props.dispatch(getCurrentSession())
    const session = this.getSession()
    this.props.dispatch(checkIfNalTaxesOnlyFlagIsEnabled())
    const { employee, assignedShop } = session || {}
    const { role } = employee || {}
    const { allowDelivery } = assignedShop || {}
    initHubSpot(dispatch, employee)
    const isPricingTemplatesEnabled = await isFeatureFlagEnable(
      UnleashToggles.MFE_COMPANY_PRICING_TEMPLATES,
    )

    let res = await dispatch(getCompanyFeatures())
    let enableLabelMaker = await dispatch(isLabelMakerEnabled())
    if (this._isMounted) {
      this.setState(
        {
          companyFeatures: res,
          allowDelivery, //save allowDelivery reference
        },
        () => {
          this.props.dispatch(setCompanyFeatures(res))
          const isInternal = this.props.authReducer.session?.employee?.internal || false
          const isBlazeAdmin = this.props.authReducer.session?.employee?.isBlazeAdmin || false
          const availableTabs = settingsTabs(isDevEnvironment, isBlazeAdmin).filter((tab) => {
            tab.childrenList = tab.childrenList.filter((child) => {
              if (child.url === 'labels') {
                return enableLabelMaker || false
              }
              if (child.url === 'deliverytax') {
                this.setState({ deliveryTaxTab: child })
                return allowDelivery || false
              }

              if (child.url === 'pricingtemplate') {
                return (!isPricingTemplatesEnabled || isInternal || isBlazeAdmin) ?? true
              }

              return true
            })
            if (tab.url == 'development') {
              return isDevEnvironment || isBlazeAdmin
            }

            if (tab.url === 'master-catalog') {
              return (res && res.enableMasterCatalog) || false
            }
            if (tab.url === 'insights') {
              return (
                (role && role.permissions && role.permissions.includes('WebInsightsReportView')) ||
                false
              )
            }
            return true
          })
          let sidebarListFiltered = this.filterSpenceStrongholdWmDispatchFromList(availableTabs)
          this.filterMfgFromList(sidebarListFiltered)
          this.setFeatureFlags()
        },
      )
    }
  }

  filterMfgFromList(sidebarListFiltered) {
    let filteredList = []
    let isMfgAvailable = this.isMfgAvailable()
    if (isMfgAvailable) {
      filteredList = sidebarListFiltered
    } else {
      filteredList =
        sidebarListFiltered && sidebarListFiltered.filter((i) => i.url !== 'manufacturing')
    }
    this.setState({ filteredList: filteredList })
    this.setState({ enableMfg: isMfgAvailable })
  }

  isMfgAvailable() {
    const { session = {} } = this.props.authReducer
    const { assignedShop = {} } = session || {}

    return assignedShop.enableMfg
  }

  filterSpenceStrongholdWmDispatchFromList(availableTabs) {
    let filteredList = []
    if (this.isSpenceAvailable() && this.isStrongholdAvailable() && this.isWMDispatchAvailable()) {
      filteredList = availableTabs
    } else {
      for (let item of availableTabs) {
        if (item.url === 'integration') {
          let newChildrenList =
            (item.childrenList &&
              item.childrenList.filter(
                (i) =>
                  (this.isSpenceAvailable() || i.url !== 'spence') &&
                  (this.isStrongholdAvailable() || i.url !== 'stronghold') &&
                  (this.isWMDispatchAvailable() || i.url !== 'wmDispatch'),
              )) ||
            []
          item.childrenList = newChildrenList
        } else if (item.url === 'insights' && !this.isAdmin() && !this.hasAnyInsightsRole()) {
          let newChildrenList =
            (item.childrenList &&
              item.childrenList.filter((i) => i.url !== 'syncInsightsPermissions')) ||
            []
          item.childrenList = newChildrenList
        }
        filteredList = [...filteredList, item]
      }
    }
    this.setState({
      filteredList: filteredList,
    })

    return filteredList
  }

  isAdmin() {
    const session = this.getSession()
    const { employee } = session || {}
    const { role } = employee || {}
    return role.name === 'Admin'
  }

  hasAnyInsightsRole() {
    return (
      this.props.companyReducer &&
      this.props.companyReducer.companyFeatures &&
      this.props.companyReducer.companyFeatures.hasAnyInsightsRole
    )
  }

  isSpenceAvailable() {
    const { session = {} } = this.props.authReducer
    const { assignedShop = {} } = session || {}
    const { companyFeatures = {} } = this.state
    const { spencePaymentByShops = {} } = companyFeatures

    let shopId = assignedShop && assignedShop.id
    let spencePaymentShopIds = Object.keys(spencePaymentByShops)

    if (spencePaymentShopIds.length === 0 || !Boolean(shopId)) {
      return false
    }

    return !!Boolean(spencePaymentByShops[shopId])
  }

  isStrongholdAvailable() {
    const { session = {} } = this.props.authReducer
    const { assignedShop = {} } = session || {}
    const { companyFeatures = {} } = this.state
    const { strongholdPaymentByShops = {} } = companyFeatures

    let shopId = assignedShop && assignedShop.id
    let strongholdPaymentShopIds = Object.keys(strongholdPaymentByShops)

    if (strongholdPaymentShopIds.length === 0 || !Boolean(shopId)) {
      return false
    }

    return !!Boolean(strongholdPaymentByShops[shopId])
  }

  isWMDispatchAvailable() {
    const { session = {} } = this.props.authReducer
    const { assignedShop = {} } = session || {}
    const { companyFeatures = {} } = this.state
    const { wmDispatch = [] } = companyFeatures

    let shopId = assignedShop && assignedShop.id
    let wmDispatchIds = Object.keys(wmDispatch)

    if (wmDispatchIds.length === 0 || !Boolean(shopId) || !wmDispatch[shopId]) {
      return !!false
    }

    return !!Boolean(wmDispatch[shopId].enable)
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen })
  }

  onItemClick = (item, parentItem) => {
    this.props.history.push(`/settings/${parentItem.url}/${item.url}`)
    if (window.innerWidth < 989) {
      this.handleDrawerToggle()
    }
  }

  logout = () => {
    logOut().then(() => {
      this.props.history.push('/')
    })
  }

  toggleDropdown = (e) => {
    e.stopPropagation()
    this.setState({ dropdown: !this.state.dropdown })
  }

  findShop = (id, shops) => {
    const shop = shops.find((item) => item.id === id) || {}
    return shop.name || ''
  }

  handleChange = (obj) => {
    this.setState({ dropdown: false })
    let { session = {} } = this.props.authReducer
    let { assignedShop } = session || {}
    if (obj.id === assignedShop.id) {
      return false
    }

    const splittedRoutes = this.props.location.pathname.split('/')

    const currentRoute = splittedRoutes[splittedRoutes.length - 1]
    const isBlazeAdmin = !!this.props.authReducer.session?.employee?.isBlazeAdmin
    if (obj.appTarget === 'Grow') {
      this.props.dispatch(changeShop(obj.id, 'Sales')).then((res) => {
        if (checkIsAppTargetRoute(obj.appTarget, currentRoute, isDevEnvironment, isBlazeAdmin)) {
          window.location.reload()
        } else {
          this.props.history.push('/settings/shop')
          window.location.reload()
        }
      })
    } else {
      this.props.dispatch(changeShop(obj.id)).then((res) => {
        if (checkIsAppTargetRoute(obj.appTarget, currentRoute, isDevEnvironment, isBlazeAdmin)) {
          window.location.reload()
        } else {
          this.props.history.push('/settings/shop')
          window.location.reload()
        }
      })
    }
  }

  goToPage = (url) => {
    this.props.history.push(`/${url}`)
  }

  returnToShop = (shop) => {
    let host = ''
    const returnShopId = window.localStorage.getItem('returnShopId')
    const returnUrl = window.localStorage.getItem('returnUrl')
    if (!shop) {
      return this.props.history.push('/switch')
    } else {
      host = appTargets[_.capitalize(shop)]
    }
    if (returnUrl === 'grow') {
      this.props
        .dispatch(
          switchApp({
            appName: _.capitalize(shop),
            shopId: returnShopId,
            growAppType: 'Sales',
          }),
        )
        .then((res) => {
          let token = res.accessToken // eslint-disable-line
          token = decodeURI(res.accessToken)
          //console.log(JSON.stringify(res), "switch app");
          window.location.href = `${host}/login?token=${res.accessToken}&shop=${returnShopId}`
        })
        .catch((err) => {
          console.log(err)
        })
    } else if (shop === 'distribution') {
      this.props
        .dispatch(
          switchApp({
            appName: _.capitalize('distribution'),
            shopId: returnShopId,
          }),
        )
        .then((res) => {
          window.location.href = `${host}/login?token=${res.accessToken}&shop=${returnShopId}`
        })
        .catch((err) => console.log(err))
    } else if (shop === 'dispatch') {
      this.props
        .dispatch(switchApp({ appName: _.capitalize('dispatch'), shopId: returnShopId }))
        .then((res) => {
          window.location.href = `${host}/login?token=${res.accessToken}&shop=${returnShopId}`
        })
        .catch((err) => console.log(err))
    } else {
      this.props
        .dispatch(switchApp({ appName: _.capitalize(shop), shopId: returnShopId }))
        .then((res) => {
          console.log(JSON.stringify(res), 'switch app')
          const fbURL = LocalStorage.getFeatureBranchUrl()
          host = fbURL || host
          LocalStorage.removeFeatureBranchUrl()

          let ref = `${host}/login?token=${res.accessToken}&shop=${returnShopId}`
          if (isDevEnvironment) {
            ref = `${host}/login?token=${res.accessToken}&shop=${returnShopId}&apiUrl=${apiUrl}`
          }
          window.location.href = ref
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.authReducer.session.assignedShop.enableMfg !==
      prevProps.authReducer.session.assignedShop.enableMfg
    ) {
      let enableMfgNow = this.props.authReducer.session.assignedShop.enableMfg
      if (enableMfgNow) {
        //the filteredList has not manufacturing menu
        let listWithMfg = [...this.state.filteredList]
        const isBlazeAdmin = !!this.props.authReducer.session?.employee?.isBlazeAdmin
        let mfgSubmenu = settingsTabs(isDevEnvironment, isBlazeAdmin).find(
          (submenu) => submenu.url === 'manufacturing',
        )
        listWithMfg.push(mfgSubmenu)
        this.setState({ filteredList: listWithMfg, enableMfg: enableMfgNow })
      } else {
        //the filteredList has manufacturing menu
        this.filterMfgFromList(this.state.filteredList)
      }
    }
  }

  flexRoot = () => {
    let path = this.props.location.pathname
    if (
      path === '/settings/master-catalog/products' ||
      path === '/settings/master-catalog/categories'
    ) {
      return 'master-catalog-tables'
    } else {
      return 'root-drawer'
    }
  }

  render() {
    let rootClass = this.flexRoot(this.props.location.pathname)
    const { classes, theme, match } = this.props
    const { filteredList } = this.state
    const { routeTitle } = this.props.currentPageReducer
    const { pathname } = this.props.location

    const activePath = pathname.split(match.url)

    let currentUrl = ''
    let currentRoute = ''

    if (activePath.length && typeof activePath[1] !== 'undefined') {
      currentUrl = activePath[1].split('/')[1] || 'shop'
      currentRoute = activePath[1].split('/')[2] || ''
    }

    const { session = {} } = this.props.authReducer
    const { assignedShop = {}, employeeShops = [] } = session || {}
    const images = {
      Distribution: distributionLogo,
      Retail: retailLogo,
      Grow: growLogo,
    }

    const shopDetails = {}

    employeeShops &&
      employeeShops.length &&
      employeeShops
        .filter((shop) => shop.active)
        .forEach((item, i) => {
          if (shopDetails[item.appTarget]) {
            shopDetails[item.appTarget].push(item)
          } else {
            shopDetails[item.appTarget] = [item]
          }
        })

    const returnUrl = window.localStorage.getItem('returnUrl')
    let returnOptions = {
      grow: 'Grow',
      distribution: 'Distro',
      apps: 'Apps',
      retail: 'Retail',
      dispatch: 'Dispatch',
    }
    const drawer = (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className={classes.toolbar}>
          <a
            data-cy="lnk-back-to"
            href="javascript:void(0);"
            className={classes.stripedLink}
            onClick={() => this.returnToShop(returnUrl)}
          >
            <Typography variant="title" color="inherit" noWrap className="text-capitalize">
              <ArrowBackIcon
                style={{
                  float: 'left',
                  marginRight: 10,
                }}
              />{' '}
              Back To {returnUrl ? returnOptions[returnUrl] : returnOptions['apps']}
            </Typography>
          </a>
        </div>
        <Divider />
        <ExpandableList
          list={filteredList}
          onItemClick={this.onItemClick}
          currentUrl={currentUrl}
          currentRoute={currentRoute}
          assignedShop={assignedShop}
          goToPage={this.goToPage}
        />
      </div>
    )

    const isBlazeAdmin = !!this.props.authReducer.session?.employee?.isBlazeAdmin
    return (
      <div className={`${classes.root} ${rootClass}`}>
        <AppBar
          className={classNames(classes.appBar, this.state.mobileOpen && classes.appBarShift)}
          position="fixed"
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={this.handleDrawerToggle}
              className={classes.navIconHide}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="title" color="inherit" noWrap className="page-title">
              {routeTitle === 'SpringBig' ? routeTitle.toLowerCase() : routeTitle}
            </Typography>
            <div className={classes.shopToolbar}>
              <div className="shopDropdown white" onClick={this.toggleDropdown}>
                <div>
                  <span>
                    {this.findShop(assignedShop.id, employeeShops)}
                    <i className="material-icons" style={{ float: 'right' }}>
                      keyboard_arrow_down
                    </i>
                  </span>
                </div>
                {this.state.dropdown ? (
                  <Paper onClick={(e) => e.stopPropagation()} className="arrow_box dropdownInner">
                    <div className="main_menu">
                      <h3
                        style={{
                          textAlign: 'center',
                          display: 'block',
                          border: 'none',
                          marginBottom: 30,
                        }}
                      >
                        Switch App Settings
                      </h3>
                      <div className="flex-Grid">
                        {_.map(shopDetails).map((item, key) => (
                          <li key={key}>
                            <span>
                              <img src={images[Object.keys(shopDetails)[key]]} alt="" />
                            </span>
                            <ul>
                              <h3>
                                BLAZE{' '}
                                {Object.keys(shopDetails)[key] === 'Distribution'
                                  ? 'Distro'
                                  : Object.keys(shopDetails)[key]}
                              </h3>
                              {item.map((menu, i) => (
                                <li
                                  key={i}
                                  className="shopElement"
                                  onClick={this.handleChange.bind(this, menu)}
                                >
                                  <span>
                                    {menu.id === assignedShop.id ? (
                                      <b style={{ color: 'orange' }}>{menu.name}</b>
                                    ) : (
                                      menu.name
                                    )}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </li>
                        ))}
                      </div>
                    </div>
                  </Paper>
                ) : null}
              </div>

              <IconButton color="inherit" aria-label="log out" onClick={this.logout}>
                <PowerSettingsNewIcon />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={this.state.mobileOpen}
            onClose={this.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
              docked: classes.docked,
            }}
            ModalProps={{
              keepMounted: true,
            }}
            PaperProps={{
              style: {
                height: '100%',
              },
              className: 'settings_drawer',
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css" className="left-drawer">
          {this.state.mobileOpen ? (
            <Drawer
              variant="permanent"
              open={this.state.mobileOpen}
              onClose={this.handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
                docked: classes.docked,
              }}
            >
              {drawer}
            </Drawer>
          ) : null}
        </Hidden>
        <main className={`${classes.content} responsive-main-container`}>
          <div className={classes.toolbar} />
          <ProtectedRoute exact path={`${match.url}/`} component={CompanyPage} />
          <ProtectedRoute path={`${match.url}/company/`} component={CompanyPage} />
          <ProtectedRoute path={`${match.url}/shop/`} component={ShopPage} />
          <ProtectedRoute path={`${match.url}/manage`} component={ManageEmployees} />
          <ProtectedRoute path={`${match.url}/integration/`} component={IntegrationPage} />
          <ProtectedRoute path={`${match.url}/plugins/`} component={PluginsPage} />
          {this.state.enableMfg ? (
            <ApolloRoute path={`${match.url}/manufacturing`} component={ManageManufacturing} />
          ) : null}
          <ProtectedRoute exact path={`${match.url}/billing/`} component={BillingPage} />
          <ProtectedRoute path={`${match.url}/master-catalog/`} component={MasterCatalogPage} />
          <ProtectedRoute path={`${match.url}/insights/`} component={InsightsPage} />
          {isBlazeAdmin || isDevEnvironment ? (
            <ProtectedRoute path={`${match.url}/development/`} component={DevelopmentPage} />
          ) : null}
          <div className="full-width switch-app-footer pt-4">
            <Footer />
          </div>
        </main>
      </div>
    )
  }
}

ResponsiveDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default connect((state) => ({
  currentPageReducer: state.currentPageReducer,
  authReducer: state.authReducer,
  companyReducer: state.companyReducer,
  dispatch: state.dispatch,
}))(withStyles(styles, { withTheme: true })(ResponsiveDrawer))



// WEBPACK FOOTER //
// ./src/containers/Settings/index.js